import { C_REALESTATE_TYPES } from "@/src-refactor/modules/shared/model/const/property/real-estate-type.const";
import { SchemaItemGeneric } from "@rf/schemas/item-generic.shema";
import {
  checkTypeIsNoBroker,
  checkTypeProperty,
  checkTypeRent,
  checkTypeSale,
  enumKeyFormPropery
} from "../helps";
import { C_ASSOCIATES_TYPES } from "@/src-refactor/modules/shared/model/const/property/associates-types.conts";
import { CRegexp } from "@/src-refactor/modules/shared/model/const/regexp/regexp.const";
import {
  A_CURRENCY,
  C_CURRENCY
} from "@/src-refactor/modules/shared/model/const/currency.conts";
import { I_GENERIC_ITEMS } from "@/src-refactor/modules/shared/model/interface/items.interface";
import HCheckArray from "@rf-helper/check-have-value";
import alterEstateSchema from "./alteEstate.schema";
import emojiRegex from "emoji-regex";
import { Label } from "@mui/icons-material";
import { array, string, boolean } from "@yup";
import featureIndicators from "../../model/feature-indicators";
const descriptionStepSchema = {
  // description
  type_property: array()
    .label("Tipo de propiedad")
    .of(SchemaItemGeneric)
    .default([C_REALESTATE_TYPES.APARTMENT])
    .min(1, "Debe seleccionar al menos un tipo de propiedad")
    .required("El tipo de propiedad es requerido"),

  name_property: string()
    .label("Nombre de la propiedad")
    .default("")
    .test("no-emojis", "No se permiten emoticones", value => {
      const regex = emojiRegex();
      return !regex.test(value || "");
    })
    .max(35, "Solo puede colocar un máximo de 35 caracteres")
    .required("El nombre de la propiedad es requerido"),
  business_types_property: array()
    .label("Tipo de negocio")
    .of(SchemaItemGeneric)
    .default([])
    .min(1, "Debe seleccionar al menos un tipo de negocio")
    .required("El tipo de negocio es requerido"),
  detail_business_property: array()
    .label("Detalle de negocio")
    .of(SchemaItemGeneric)
    .default([])
    .when([enumKeyFormPropery.isProject], {
      is: (isProject: any) => !isProject,
      then: schema =>
        schema.min(1, "Debe seleccionar al menos un detalle de negocio"),
      otherwise: schema => schema
    }),
  uses_property: array()
    .label("Usos de la propiedad")
    .of(SchemaItemGeneric)
    .default([])
    .min(1, "Debe seleccionar al menos un uso de la propiedad")
    .required("El uso de la propiedad es requerido"),
  condition_property: array()
    .label("Condición de la propiedad")
    .of(SchemaItemGeneric)
    .default([])
    .min(1, "Debe seleccionar al menos una condición de la propiedad")
    .required("La condición de la propiedad es requerida"),
  associates_type_property: array()
    .label("Tipo de asociado")
    .of(SchemaItemGeneric)
    .min(1, "Debe seleccionar al menos un tipo de asociación")
    .required("El tipo de asociado es requerido")
    .default([C_ASSOCIATES_TYPES.CO_BROKER]),
  arrangement_type_property: array()
    .label("Tipo de arreglo")
    .of(SchemaItemGeneric)
    .default([])
    .min(1, "Debe seleccionar al menos un tipo de arreglo de la propiedad")
    .required("El tipo de arreglo de la propiedad es requerido"),
  visit_type_property: array()
    .label("Tipo de visita")
    .of(SchemaItemGeneric)
    .default([])
    .when([enumKeyFormPropery.isProject], {
      is: (isProject: any) => !isProject,
      then: schema => schema.min(1, "Debe seleccionar al menos un tipo de visita"),
      otherwise: schema => schema
    })
    .required("El tipo de visita es requerido"),
  is_habited_property: array()
    .label("¿Está habitado?")
    .of(SchemaItemGeneric)
    .default([])
    .when([enumKeyFormPropery.isProject], {
      is: (isProject: boolean) => {
        return !isProject;
      },
      then: schema => schema.min(1, "Especifique si la propiedad está habitada"),
      otherwise: schema => schema
    }),
  is_collection_property: array()
    .label("Propiedad de colección")
    .of(SchemaItemGeneric)
    .default([]),
  meter_land_property: string()
    .label("Metros de solar")
    .default("")
    .matches(CRegexp.NUMBER_MAYOR_CERO, {
      excludeEmptyString: true,
      message: "Debe ser mayor a 0 o numero invalido"
    })
    .when([enumKeyFormPropery.typeProperty, enumKeyFormPropery.isProject], {
      is: (type: any, isProject: any) =>
        checkTypeProperty({
          typePropertyValue: type,
          isProjectValue: isProject,
          propertyTypeIds: featureIndicators.meterLand,
          projectTypeIds: []
        }),
      then: schema => schema.required("Los metros de solar son requeridos"),
      otherwise: schema => schema
    }),
  meter_construction_property: string()
    .label("Metros de construcción")
    .default("")
    .matches(CRegexp.NUMBER_MAYOR_CERO, {
      excludeEmptyString: true,
      message: "Debe ser mayor a 0 o numero invalido"
    })
    .when([enumKeyFormPropery.typeProperty, enumKeyFormPropery.isProject], {
      is: (type: any, isProject: any) =>
        checkTypeProperty({
          typePropertyValue: type,
          isProjectValue: isProject,
          propertyTypeIds: featureIndicators.meterConstruction,
          projectTypeIds: []
        }),
      then: schema => schema.required("Los metros de construcción son requeridos"),
      otherwise: schema => schema
    }),

  price_sale_property: string()
    .label("Precio de venta")
    .default("")
    .matches(CRegexp.NUMBER_MAYOR_CERO, {
      excludeEmptyString: true,
      message: "Debe ser mayor a 0 o numero invalido"
    })
    .when([enumKeyFormPropery.businessTypes, enumKeyFormPropery.isProject], {
      is: checkTypeSale,
      then: schema => schema.required("El precio de venta es requerido"),
      otherwise: schema => schema
    }),

  currency_sale_property: array()
    .label("Moneda de venta")
    .of(SchemaItemGeneric)
    .default([C_CURRENCY.RD])
    .when([enumKeyFormPropery.businessTypes, enumKeyFormPropery.isProject], {
      is: checkTypeSale,
      then: (schema: any) =>
        schema.min(1, "Debe seleccionar al menos una moneda de venta"),
      otherwise: (schema: any) => schema
    }),

  price_rent_property: string()
    .label("Precio de alquiler")
    .default("")
    .matches(CRegexp.NUMBER_MAYOR_CERO, {
      excludeEmptyString: true,
      message: "Debe ser mayor a 0 o numero invalido"
    })
    .when([enumKeyFormPropery.businessTypes, enumKeyFormPropery.isProject], {
      is: checkTypeRent,
      then: schema => schema.required("El precio de alquiler es requerido"),
      otherwise: schema => schema
    }),

  currency_rent_property: array()
    .label("Moneda de alquiler")
    .of(SchemaItemGeneric)
    .default([C_CURRENCY.RD])
    .when([enumKeyFormPropery.businessTypes, enumKeyFormPropery.isProject], {
      is: checkTypeRent,
      then: (schema: any) =>
        schema.min(1, "Debe seleccionar al menos una moneda de alquiler"),
      otherwise: (schema: any) => schema
    }),

  characteristics_roof_form_property: array()
    .label("Características de forma de techo")
    .of(SchemaItemGeneric)
    .default([])
    .when([enumKeyFormPropery.typeProperty, enumKeyFormPropery.isProject], {
      is: (type: any, isProject: any) =>
        checkTypeProperty({
          typePropertyValue: type,
          isProjectValue: isProject,
          propertyTypeIds: featureIndicators.roofForm,
          projectTypeIds: []
        }),
      then: (schema: any) =>
        schema.min(
          1,
          "Debe seleccionar al menos una característica de forma de techo"
        ),
      otherwise: (schema: any) => schema
    }),

  characteristics_roof_property: array()
    .label("Características de techo")
    .of(SchemaItemGeneric)
    .default([])
    .when([enumKeyFormPropery.typeProperty, enumKeyFormPropery.isProject], {
      is: (type: any, isProject: any) =>
        checkTypeProperty({
          typePropertyValue: type,
          isProjectValue: isProject,
          propertyTypeIds: featureIndicators.roof,
          projectTypeIds: []
        }),
      then: (schema: any) =>
        schema.min(1, "Debe seleccionar al menos una característica de techo"),
      otherwise: (schema: any) => schema
    }),
  characteristics_frames_property: array()
    .label("Características de marcos")
    .of(SchemaItemGeneric)
    .default([])
    .when([enumKeyFormPropery.typeProperty, enumKeyFormPropery.isProject], {
      is: (type: any, isProject: any) =>
        checkTypeProperty({
          typePropertyValue: type,
          isProjectValue: isProject,
          propertyTypeIds: featureIndicators.frames,
          projectTypeIds: []
        }),
      then: schema =>
        schema.min(1, "Debe seleccionar al menos una característica de marcos"),
      otherwise: schema => schema
    }),
  characteristics_door_property: array()
    .label("Características de puerta")
    .of(SchemaItemGeneric)
    .default([])
    .when([enumKeyFormPropery.typeProperty, enumKeyFormPropery.isProject], {
      is: (type: any, isProject: any) =>
        checkTypeProperty({
          typePropertyValue: type,
          isProjectValue: isProject,
          propertyTypeIds: featureIndicators.doors,
          projectTypeIds: []
        }),
      then: (schema: any) =>
        schema.min(1, "Debe seleccionar al menos una característica de puerta"),
      otherwise: (schema: any) => schema
    }),
  characteristics_closets_property: array()
    .label("Características de closet")
    .of(SchemaItemGeneric)
    .default([])
    .when([enumKeyFormPropery.typeProperty, enumKeyFormPropery.isProject], {
      is: (type: any, isProject: any) =>
        checkTypeProperty({
          typePropertyValue: type,
          isProjectValue: isProject,
          propertyTypeIds: featureIndicators.closets,
          projectTypeIds: []
        }),
      then: (schema: any) =>
        schema.min(1, "Debe seleccionar al menos una característica de closet "),
      otherwise: (schema: any) => schema
    }),
  characteristics_windows_property: array()
    .label("Características de ventana")
    .of(SchemaItemGeneric)
    .default([])
    .when([enumKeyFormPropery.typeProperty, enumKeyFormPropery.isProject], {
      is: (type: any, isProject: any) =>
        checkTypeProperty({
          typePropertyValue: type,
          isProjectValue: isProject,
          propertyTypeIds: featureIndicators.windows,
          projectTypeIds: []
        }),
      then: (schema: any) =>
        schema.min(1, "Debe seleccionar al menos una característica de ventana"),
      otherwise: (schema: any) => schema
    }),
  characteristics_cabinets_property: array()
    .label("Características de gabinetes")
    .of(SchemaItemGeneric)
    .default([])
    .when([enumKeyFormPropery.typeProperty, enumKeyFormPropery.isProject], {
      is: (type: any, isProject: any) =>
        checkTypeProperty({
          typePropertyValue: type,
          isProjectValue: isProject,
          propertyTypeIds: featureIndicators.cabinets,
          projectTypeIds: []
        }),
      then: (schema: any) =>
        schema.min(1, "Debe seleccionar al menos una característica de gabinetes "),
      otherwise: (schema: any) => schema
    }),
  characteristics_floors_property: array()
    .label("Características de pisos")
    .of(SchemaItemGeneric)
    .default([])
    .when([enumKeyFormPropery.typeProperty, enumKeyFormPropery.isProject], {
      is: (type: any, isProject: any) =>
        checkTypeProperty({
          typePropertyValue: type,
          isProjectValue: isProject,
          propertyTypeIds: featureIndicators.floors,
          projectTypeIds: []
        }),
      then: (schema: any) =>
        schema.min(1, "Debe seleccionar al menos una característica de pisos "),
      otherwise: (schema: any) => schema
    }),
  characteristics_type_house_property: array()
    .label("Características de tipo de casa")
    .of(SchemaItemGeneric)
    .default([])
    .when([enumKeyFormPropery.typeProperty, enumKeyFormPropery.isProject], {
      is: (type: any, isProject: any) =>
        checkTypeProperty({
          typePropertyValue: type,
          isProjectValue: isProject,
          propertyTypeIds: featureIndicators.houseType,
          projectTypeIds: []
        }),
      then: (schema: any) =>
        schema.min(
          1,
          "Debe seleccionar al menos una característica de tipo de casa "
        ),
      otherwise: (schema: any) => schema
    }),
  currency_maintenance_property: array()
    .label("Moneda de mantenimiento")
    .of(SchemaItemGeneric)
    .default([C_CURRENCY.RD])
    .when([enumKeyFormPropery.typeProperty, enumKeyFormPropery.isProject], {
      is: (type: any) =>
        checkTypeProperty({
          typePropertyValue: type,
          isProjectValue: true,
          propertyTypeIds: [],
          projectTypeIds: []
        }),
      then: (schema: any) =>
        schema.min(1, "Debe seleccionar al menos una moneda de mantenimiento"),
      otherwise: (schema: any) => schema
    }),
  price_maintenance_property: string()
    .label("Precio de mantenimiento")
    .default("")
    .matches(CRegexp.NUMBER_MAYOR_CERO, {
      excludeEmptyString: true,
      message: "Debe ser mayor a 0 o numero invalido"
    })
    .when([enumKeyFormPropery.typeProperty, enumKeyFormPropery.isProject], {
      is: (type: any) =>
        checkTypeProperty({
          typePropertyValue: type,
          isProjectValue: true,
          propertyTypeIds: featureIndicators.maintenance,
          projectTypeIds: []
        }),
      then: (schema: any) =>
        schema.required("El precio de mantenimiento es requerido"),
      otherwise: (schema: any) => schema
    }),
  tareas_property: string().label("Tareas").default(""),
  features_property: array()
    .label("Características")
    .of(SchemaItemGeneric)
    .default([]),
  bedrooms_property: array()
    .label("Habitaciones")
    .default([])
    .when([enumKeyFormPropery.typeProperty, enumKeyFormPropery.isProject], {
      is: (type: any, isProject: any) =>
        checkTypeProperty({
          typePropertyValue: type,
          isProjectValue: isProject,
          propertyTypeIds: featureIndicators.bedrooms,
          projectTypeIds: []
        }),
      then: (schema: any) => schema.min(1, "Debe especificar una cantidad"),
      otherwise: (schema: any) => schema
    }),
  bathrooms_property: array()
    .label("Baños")
    .default([])
    .when([enumKeyFormPropery.typeProperty, enumKeyFormPropery.isProject], {
      is: (type: any, isProject: any) =>
        checkTypeProperty({
          typePropertyValue: type,
          isProjectValue: isProject,
          propertyTypeIds: featureIndicators.bathrooms,
          projectTypeIds: []
        }),
      then: (schema: any) => schema.min(1, "Debe especificar una cantidad"),
      otherwise: (schema: any) => schema
    }),
  half_bathrooms_property: array()
    .label("Medio baños")
    .default([])
    .when([enumKeyFormPropery.typeProperty, enumKeyFormPropery.isProject], {
      is: (type: any, isProject: any) =>
        checkTypeProperty({
          typePropertyValue: type,
          isProjectValue: isProject,
          propertyTypeIds: featureIndicators.halfBathrooms,
          projectTypeIds: []
        }),
      then: (schema: any) => schema.min(1, "Debe especificar una cantidad"),
      otherwise: (schema: any) => schema
    }),
  parking_spots_property: array()
    .label("Parqueos")
    .default([])
    .when([enumKeyFormPropery.typeProperty, enumKeyFormPropery.isProject], {
      is: (type: any, isProject: any) =>
        checkTypeProperty({
          typePropertyValue: type,
          isProjectValue: isProject,
          propertyTypeIds: featureIndicators.parkingSpots,
          projectTypeIds: []
        }),
      then: (schema: any) => schema.min(1, "Debe especificar una cantidad"),
      otherwise: (schema: any) => schema
    }),
  pumps_property: array()
    .label("Bombas")
    .default([])
    .when([enumKeyFormPropery.typeProperty, enumKeyFormPropery.isProject], {
      is: (type: any, isProject: any) =>
        checkTypeProperty({
          typePropertyValue: type,
          isProjectValue: isProject,
          propertyTypeIds: featureIndicators.pumps,
          projectTypeIds: []
        }),
      then: (schema: any) => schema.min(1, "Debe especificar una cantidad"),
      otherwise: (schema: any) => schema
    }),
  level_floor_property: array()
    .label("Niveles")
    .default([])
    .when([enumKeyFormPropery.typeProperty, enumKeyFormPropery.isProject], {
      is: (type: any, isProject: any) =>
        checkTypeProperty({
          typePropertyValue: type,
          isProjectValue: isProject,
          propertyTypeIds: featureIndicators.levelFloor,
          projectTypeIds: []
        }),
      then: (schema: any) => schema.min(1, "Debe especificar una cantidad"),
      otherwise: (schema: any) => schema
    }),
  total_floor_property: array()
    .label("Total de niveles")
    .default([])
    .when([enumKeyFormPropery.typeProperty, enumKeyFormPropery.isProject], {
      is: (type: any, isProject: any) =>
        checkTypeProperty({
          typePropertyValue: type,
          isProjectValue: isProject,
          propertyTypeIds: featureIndicators.totalLevels,
          projectTypeIds: []
        }),
      then: (schema: any) => schema.min(1, "Debe especificar una cantidad"),
      otherwise: (schema: any) => schema
    }),

  ...alterEstateSchema,

  is_study_property: array()
    .label("Estudio")
    .of(SchemaItemGeneric)
    .default([])
    .when([enumKeyFormPropery.isProject, enumKeyFormPropery.typeProperty], {
      is: (isProject: boolean, type: I_GENERIC_ITEMS[]) => {
        if (isProject) {
          return false;
        }
        return HCheckArray(type) && featureIndicators.studio.includes(type[0].id);
      },
      then: (schema: any) => schema.min(1, "Debe debe indicar si es un estudio"),
      otherwise: (schema: any) => schema
    }),

  brokers_property: array()
    .label("Agentes")
    .default([])
    .of(SchemaItemGeneric)
    .default([])
    .when("associates_type_property", {
      is: checkTypeIsNoBroker,
      then: (schema: any) => schema,
      otherwise: (schema: any) =>
        schema
          .min(1, "Debe seleccionar al menos un agente")
          .required("El broker es requerido")
    }),
  fee_sale_percentage_commission_property: string()
    .label("Porcentaje de comisión")
    .default("")
    .when([enumKeyFormPropery.businessTypes, enumKeyFormPropery.isProject], {
      is: (businessTypes: I_GENERIC_ITEMS[], isProject: boolean) => {
        if (isProject) {
          return true;
        } else {
          return checkTypeSale(businessTypes, isProject);
        }
      },
      then: (schema: any) =>
        schema
          .matches(CRegexp.PERCENT, {
            excludeEmptyString: true,
            message:
              "Porcentaje invalido, debe ser entre 0 a 100 y con dos decimales"
          })
          .required("El porcentaje de comisión es requerido"),
      otherwise: (schema: any) => schema
    }),
  fee_sale_selling_agent_commission_percentage: string()
    .label("Porcentaje de comisión agente vendedor")
    .default("")
    .when([enumKeyFormPropery.businessTypes, enumKeyFormPropery.isProject], {
      is: (businessTypes: I_GENERIC_ITEMS[], isProject: boolean) => {
        if (isProject) {
          return true;
        } else {
          return checkTypeSale(businessTypes, isProject);
        }
      },
      then: (schema: any) =>
        schema
          .matches(CRegexp.PERCENT, {
            excludeEmptyString: true,
            message:
              "Porcentaje invalido, debe ser entre 0 a 100 y con dos decimales"
          })
          .required("El porcentaje de comisión agente vendedor es requerido"),
      otherwise: (schema: any) => schema
    }),
  fee_rent: array()
    .label("Comisión de alquiler")
    .of(SchemaItemGeneric)
    .default([])
    .when([enumKeyFormPropery.businessTypes, enumKeyFormPropery.isProject], {
      is: checkTypeRent,
      then: (schema: any) => schema.min(1, "La comisión de alquiler es requerida"),
      otherwise: (schema: any) => schema
    }),
  master_broker_property: boolean()
    .label("Broker master")
    .default(false)
    .when([enumKeyFormPropery.isProject], {
      is: (isProject: any) => isProject,
      then: (schema: any) => schema.default(false),
      otherwise: (schema: any) => schema
    }),
  price_separation_property: string()
    .label("Precio de separación")
    .default("")
    .when([enumKeyFormPropery.isProject], {
      is: (isProject: any) => isProject,
      then: (schema: any) => schema.required("El precio de separación es requerido"),
      otherwise: (schema: any) => schema
    }),
  currency_separation_property: array()
    .label("Moneda de separación")
    .of(SchemaItemGeneric)
    .default([C_CURRENCY.RD])
    .when([enumKeyFormPropery.isProject], {
      is: (isProject: any) => isProject,
      then: (schema: any) => schema.min(1, "Debe seleccionar una moneda"),
      otherwise: (schema: any) => schema
    }),
  deadline_property: string()
    .label("Fecha de entrega")
    .default("")
    .when([enumKeyFormPropery.isProject], {
      is: (isProject: any) => isProject,
      then: (schema: any) => schema.required("La fecha de entrega es requerida"),
      otherwise: (schema: any) => schema
    }),
  feature_project_property: array()
    .label("Características de proyecto")
    .of(SchemaItemGeneric)
    .default([]),
  global_currency_property: array()
    .label("Moneda general del proyecto")
    .of(SchemaItemGeneric)
    .default([C_CURRENCY.RD])
    .when([enumKeyFormPropery.isProject], {
      is: (isProject: any) => isProject,
      then: (schema: any) => schema.min(1, "Debe seleccionar una moneda"),
      otherwise: (schema: any) => schema
    })
};

export default descriptionStepSchema;
export type TDescriptionStepSchema = typeof descriptionStepSchema;
export const CDescriptionPropertyStepSchemaKeys = Object.keys(descriptionStepSchema);
